let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dwqTf")).then(() => parcelRequire('5VFOo'));